var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 79,
    viewBox: "0 0 67 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47518 0H63.1629C65.0821 0 66.6381 1.55595 66.6381 3.47518V55.9483C66.6381 57.8675 65.0821 59.4235 63.1629 59.4235H3.47518C1.55595 59.4235 0 57.8675 0 55.9483V3.47518C0 1.55595 1.55595 0 3.47518 0V0Z",
    fill: "#D5D6DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34289 31.415H3.67871V23.0553C3.68318 21.5765 4.88267 20.3798 6.36121 20.3784H59.9086C61.3853 20.3822 62.5815 21.5784 62.5855 23.0553V30.612H60.9246V23.0553C60.922 22.4958 60.4681 22.0433 59.9086 22.0428H6.36121C5.79958 22.0435 5.34407 22.4983 5.34289 23.06V31.415Z",
    fill: "#3E6B82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8588 25.2898H63.6563C64.3819 25.2898 64.9701 25.878 64.9701 26.6036V38.7178C64.9701 39.4435 64.3819 40.0317 63.6563 40.0317H59.8588C59.1331 40.0317 58.5449 39.4435 58.5449 38.7178V26.6039C58.5449 25.878 59.1331 25.2898 59.8588 25.2898Z",
    fill: "#3A556A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98083 25.2898H6.77835C7.50398 25.2898 8.09219 25.878 8.09219 26.6036V38.7178C8.09219 39.4435 7.50398 40.0317 6.77835 40.0317H2.98083C2.25521 40.0317 1.66699 39.4435 1.66699 38.7178V26.6039C1.66699 25.878 2.25521 25.2898 2.98083 25.2898Z",
    fill: "#3A556A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2555 59.0288H58.9929C60.0124 59.0288 60.8387 59.8551 60.8387 60.8746V77.1565C60.838 78.1753 60.0117 79.0006 58.9929 78.9999H52.2543C51.2355 78.9999 50.4097 78.1741 50.4097 77.1553V60.8735C50.4097 59.8547 51.2355 59.0288 52.2543 59.0288H52.2555Z",
    fill: "#2F4859"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64514 59.0288H14.3837C15.4025 59.0288 16.2284 59.8547 16.2284 60.8735V77.1553C16.2284 78.1741 15.4025 78.9999 14.3837 78.9999H7.64514C6.62564 78.9999 5.79932 78.1736 5.79932 77.1541V60.8735C5.79932 59.8547 6.62517 59.0288 7.64396 59.0288H7.64514Z",
    fill: "#2F4859"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4405 12.6331C40.1824 9.73981 26.4562 9.73981 13.1978 12.6331C11.5934 12.995 10.4558 14.4229 10.4619 16.0676V71.3223H56.1767V16.0676C56.1825 14.4229 55.0449 12.995 53.4405 12.6331Z",
    fill: "#35825D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1763 48.2134C52.9915 48.2134 50.4097 50.7952 50.4097 53.98V71.3209H61.942V53.98C61.9418 50.7959 59.3607 48.2141 56.1763 48.2134Z",
    fill: "#2CDDC0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4617 48.2134C7.27738 48.2141 4.69629 50.7956 4.69629 53.98V71.3209H16.2286V53.98C16.2284 50.7954 13.6466 48.2134 10.4617 48.2134Z",
    fill: "#2CDDC0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4004 49.4834H45.2366V51.3617H21.4004V49.4834Z",
    fill: "#2F4859"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4004 54.0559H45.2366V55.9342H21.4004V54.0559Z",
    fill: "#2F4859"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4004 58.6299H45.2366V60.5082H21.4004V58.6299Z",
    fill: "#2F4859"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4004 63.2024H45.2366V65.0807H21.4004V63.2024Z",
    fill: "#2F4859"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2084 68.9226H3.4299C2.35465 68.9226 1.48291 69.7943 1.48291 70.8696C1.48291 71.9449 2.35465 72.8166 3.4299 72.8166H63.2084C64.2837 72.8166 65.1554 71.9449 65.1554 70.8696C65.1554 69.7943 64.2837 68.9226 63.2084 68.9226Z",
    fill: "#3E6B82"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2295 21.7646H50.411V40.3612H16.2295V21.7646Z",
    fill: "#3A556A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1611 15.1611H43.4767V18.3744H23.1611V15.1611Z",
    fill: "#3A556A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3625 50.9346C54.6386 50.9346 53.2412 52.3322 53.2412 54.0559C53.2412 55.7796 54.6386 57.1772 56.3625 57.1772C58.0865 57.1772 59.4838 55.7798 59.4838 54.0559C59.4841 52.3322 58.0865 50.9346 56.3625 50.9346Z",
    fill: "#EBF0F3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2756 50.9346C8.55166 50.9346 7.1543 52.3322 7.1543 54.0559C7.1543 55.7796 8.55166 57.1772 10.2756 57.1772C11.9996 57.1772 13.3969 55.7798 13.3969 54.0559C13.3969 52.3322 11.9996 50.9346 10.2756 50.9346Z",
    fill: "#EBF0F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3625 58.6299C54.6386 58.6299 53.2412 60.0275 53.2412 61.7512C53.2412 63.4751 54.6386 64.8725 56.3625 64.8725C58.0865 64.8725 59.4838 63.4751 59.4838 61.7512C59.4841 60.0272 58.0865 58.6299 56.3625 58.6299Z",
    fill: "#EBF0F3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2756 58.6299C8.55166 58.6299 7.1543 60.0275 7.1543 61.7512C7.1543 63.4751 8.55166 64.8725 10.2756 64.8725C11.9996 64.8725 13.3969 63.4751 13.3969 61.7512C13.3969 60.0272 11.9996 58.6299 10.2756 58.6299Z",
    fill: "#EBF0F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckFront);
export default __webpack_public_path__ + "static/media/TruckFront.38f613720275406522c8955314b0a8db.svg";
export { ForwardRef as ReactComponent };